import { ICellRendererParams } from "ag-grid-community";
import { Chip, ChipProps, Typography } from "@mui/joy";
import { AgentObj } from "@/types/interfaces/agents";

// Same colours as the names (see getStatusColor)
const STATUS_CHIP: Record<string, { label: string; color: ChipProps["color"] }> = {
  NEW: { label: "New", color: "success" },
  ACTIVE: { label: "Active", color: "primary" },
  LEAVING: { label: "Leaving", color: "warning" },
  RESIGNED: { label: "Resigned", color: "neutral" },
};

export const StatusCellRenderer = ({ value }: ICellRendererParams<AgentObj>) => {
  const status = STATUS_CHIP[value || ""];
  if (!status) return value || "-";
  // Most agents are active; only the exceptions get a chip so they stand out
  if (value === "ACTIVE")
    return (
      <Typography level="body-sm" textColor="text.secondary">
        {status.label}
      </Typography>
    );
  return (
    <Chip size="sm" variant="soft" color={status.color}>
      {status.label}
    </Chip>
  );
};
